import Swiper from "swiper";
import {Navigation} from "swiper/modules";

export default class SliderCatalogs {
    constructor() {
        const $sections = document.querySelectorAll('section.slider-catalogs');

        $sections.forEach($section => {
            const swiper = new Swiper($section.querySelector('.swiper'), {
                // configure Swiper to use modules
                modules: [Navigation],
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    disabledClass: 'swiper-button-disabled border !text-primary-darker border-primary-darker !bg-white',
                },
                slidesPerView: 1.2,
                spaceBetween: 15,
                centerInsufficientSlides: true,
                breakpoints: {
                    640: {
                        slidesPerView: 3.2,
                        spaceBetween: 32,
                    },
                }
            });
        });
    }
}

new SliderCatalogs();